<template>
  <div>
    <h4 class="mb-4">Entrer un nouveau mot de passe</h4>
    <div v-if="sent" class="mb-4">Votre mot de passe a bien ete change</div>
    <b-form @submit.stop.prevent @submit="sendPassword" novalidate v-else>
      <b-form-group label="Mot de Passe">
        <b-form-input placeholder="Mot de Passe"
                      v-model="password"
                      type="password"
                      required
                      pattern=".{6,}"></b-form-input>
        <div class="invalid-feedback">
          Ton mot de passe doit contenir au moins 6 caractères.
        </div>
      </b-form-group>
      <b-btn class="fa-pull-right" variant="primary" type="submit" v-if="!sent">Envoyer</b-btn>
    </b-form>
    <b-btn variant="outline-primary" @click="$router.push('/inscription')">Retour</b-btn>
  </div>
</template>

<script>
import {Auth} from "@/js/caller";

export default {
  name : "ResetPassword",
  props: ['token'],
  data() {
    return {
      password: "",
      sent    : false
    }
  },
  methods: {
    sendPassword() {
      Auth.ResetPassword(this.token, this.password).then(() => {
        this.sent = true;
      });
    },
  }
}
</script>

<style scoped>

</style>